export function detectTimeZone(): string {
  // Get the user's timezone using Intl API
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timeZone
  } catch (error) {
    // Fallback to a default timezone if detection fails
    return "UTC"
  }
}

export function formatTimeZone(timezone: string): string {
  try {
    // Format the timezone in a user-friendly way
    const now = new Date()
    const timeZoneOffset =
      new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        timeZoneName: "short",
      })
        .formatToParts(now)
        .find((part) => part.type === "timeZoneName")?.value || timezone

    return timeZoneOffset
  } catch (error) {
    return timezone
  }
}

